import React from "react";
import BtnReferee from "../../buttons/BtnReferee";
import PageTitle from "../../components/PageTitle";
import { useQuery } from "@tanstack/react-query";
import { axiosget } from "../../helpers/httprequest";
import Loader from "../../components/Loader";
import ErrorResponse from "../../components/ErrorResponse";
import TblReferee from "../../table/TblReferee";

const Referee = () => {
  const { isLoading, error, data } = useQuery({
    queryKey: ["listOfReferees"],
    queryFn: async () => {
      const req = await axiosget("ms_applicant_referee");
      return req;
    },
  });
  return (
    <>
      <PageTitle title={`Parents & Guardians`} sub={`Create & delete parents and guardians`} />
      {isLoading && <Loader />}
      {error || (data?.message && <ErrorResponse type={"danger"} message={error?.message ? error?.message : data?.message} />)}
      {data?.message === undefined && data && <TblReferee data={data?.data} />}
      <BtnReferee />
    </>
  );
};

export default Referee;
